import { useLocation, useNavigate } from 'react-router-dom';
import {
  Users,
  UserPlus,
  Building2,
  BookOpen,
  BookCheck,
  Bell,
  Settings,
} from 'lucide-react';

const sidebarItems = [
  {
    id: 'organization',
    label: 'Organization',
    icon: Building2,
    path: '/organization',
  },
  {
    id: 'users',
    label: 'Display Users',
    icon: Users,
    path: '/users',
  },
  {
    id: 'addUser',
    label: 'Add User',
    icon: UserPlus,
    path: '/users/add',
  },
  {
    id: 'courses',
    label: 'Courses',
    icon: BookCheck,
    path: '/courses',
  },
  {
    id: 'createCourse',
    label: 'Create Course',
    icon: BookOpen,
    path: '/courses/new',
  },
  {
    id: 'notifications',
    label: 'Notifications',
    icon: Bell,
    path: '/notifications',
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: Settings,
    path: '/settings',
  },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <aside className="w-64 bg-white shadow-md h-[calc(100vh-64px)] fixed top-16 left-0">
      <nav className="p-4">
        {sidebarItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;

          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className={`
                w-full flex items-center gap-2 px-3 py-2 mb-1 rounded-lg text-sm
                ${
                  isActive ? 'bg-accent-purple text-title' : 'hover:bg-gray-100'
                }
              `}
            >
              <Icon className="h-4 w-4" />
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
};

export default Sidebar;
